export default __webpack_public_path__ + "static/media/aboutus_card_icon2.55c42f0a.svg";